<template>
    <q-modal v-model="show_welcome" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}"  no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <!-- <q-btn flat round dense @click="show_welcome = false" icon="fas fa-times" /> -->
                <q-toolbar-title>
                    {{ welcome_banner.title }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row gutter-md">
                    <div class="col-xs-12 col-sm-12 text-center" v-if="getBanner">
                        <img :src="getBanner" :style="bannerStyle" />
                    </div>

                    <div class="col-xs-12 col-sm-12" v-if="welcome_banner.content">
                        <span v-html="welcome_banner.content"></span>
                    </div>
                </div>

                <div class="row gutter-sm justify-end q-mt-sm">
                    <div class="col-xs-12 col-sm-3" v-if="welcome_banner.banner_welcome_type_slug === 'user_logout'">
                        <q-btn color="tertiary" class="full-width" :label="$t('logout')" icon="far fa-sign-out-alt" @click="logout()" />
                    </div>

                    <div class="col-xs-12 col-sm-3" v-if="welcome_banner.banner_welcome_type_slug === 'just_confirm'">
                        <q-btn color="primary" class="full-width" :label="$t('enter')" icon="far fa-save" @click="confirmEnter()" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

export default {
    data() {
        return {
            show_welcome: false
        }
    },

    computed: {
        ...mapGetters({
            welcome_banner: 'welcome_banner/welcome_banner',
        }),

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getBanner() {
            if (this.welcome_banner.banner_welcome_images) {
                if (this.$q.platform.is.desktop) {
                    let obj = this.welcome_banner.banner_welcome_images.find((obj) => { return obj.name === 'original_desktop' })

                    if (obj) return obj.image_url
                    else {
                        let obj_alt = this.welcome_banner.banner_welcome_images.find((obj) => { return obj.name === 'original_mobile' })

                        if (obj) return obj.image_url
                    }
                }
                else if (this.$q.platform.is.mobile) {
                    let obj = this.welcome_banner.banner_welcome_images.find((obj) => { return obj.name === 'original_mobile' })

                    if (obj) return obj.image_url
                    else {
                        let obj_alt = this.welcome_banner.banner_welcome_images.find((obj) => { return obj.name === 'original_desktop' })

                        if (obj) return obj.image_url
                    }
                }
            }

            return ''
        },

        bannerStyle() {
            if (this.$q.platform.is.desktop) {
                return 'width: 100%; height: auto;'
            }
            else if (this.$q.platform.is.mobile) {
                return 'width: 100%; height: auto;'
            }
        }
    },

    methods: {
        logout() {
            this.$store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])

            firebase.auth().signOut().then(() => {

            }).catch((e) => {
                console.log(e)
            })

            setTimeout(() =>{
                this.$q.loading.hide()
                this.$router.replace({ name: 'login' })
            }, 700)
        },

        confirmEnter() {
            this.$store.dispatch('welcome_banner/SET_WELCOME_BANNER', [{}])
            this.show_welcome = false
        }
    },

    created() {
        if (this.welcome_banner.id) this.show_welcome = true
    }
}
</script>

<style>

</style>
